import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useGame } from "@/context/GameContext";
import AvatarEditor from "./AvatarEditor";
import { toast } from "sonner";

const AvatarMakerDialog = () => {
  const { state, setAvatar, avatarMakerOpen, setAvatarMakerOpen } = useGame();

  return (
    <Dialog open={avatarMakerOpen} onOpenChange={(v) => !v && setAvatarMakerOpen(false)}>
      <DialogContent
        className="max-w-3xl max-h-[92vh] overflow-y-auto rounded-3xl border-4 border-amber-300 bg-white p-5 sm:p-6"
        data-testid="avatar-maker-modal"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
            Avatar Maker
          </DialogTitle>
        </DialogHeader>
        {avatarMakerOpen && (
          <AvatarEditor
            initial={state.avatar}
            onSave={(a) => {
              setAvatar(a);
              setAvatarMakerOpen(false);
              toast.success("Looking sharp, boss!");
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AvatarMakerDialog;
